export default __webpack_public_path__ + "../staticImages/winefinder-sprite-Aroma_scharfe_gewuerze-2x.png";